// extracted by mini-css-extract-plugin
export default {"mobile":"NuberRange_mobile__7EsrB"};